/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Range_SelectInputs */



/**
* | output |
* | --- |
* | "Date Range Select" |
*
* @param {Date_Range_SelectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const date_range_select = /** @type {((inputs?: Date_Range_SelectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Range_SelectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélection de période")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datumsbereich auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona intervallo di date")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите диапазон дат")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar rango de fechas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择日期范围")
	if (locale === "ja") return /** @type {LocalizedString} */ ("日付範囲の選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दिनांक सीमा का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o intervalo de datas")
	return /** @type {LocalizedString} */ ("Date Range Select")
});